import { attachDialog, closeDialog } from '../../util/dialog_helpers.js';
import { addPageAction } from '../../util/new_relic.js';
import { getNotificationService } from '../../util/notification_service.js';

const notificationService = getNotificationService();

const attachEventHandlers = (dialog: HTMLElement) => {
  const gotItButton = dialog.querySelector('[data-id="got-it-button"]');
  if (gotItButton) {
    gotItButton.addEventListener('click', () => {
      closeDialog();
    });
  }
};

export const showCCDLaunchFailureDialog = async () => {
  addPageAction('typekit.click.use-model-font-activation-open-app-failure');
  notificationService.removeAll();

  try {
    const { dialog, dialogPromise } = await attachDialog('ccd_launch_failure_dialog') as { dialog: HTMLElement, dialogPromise: Promise<void> };

    attachEventHandlers(dialog);

    return dialogPromise;
  } catch (error) {
    console.error('Error fetching dialog template:', error);
    throw error;
  }
};
